import React from "react";

export default class FormErrorHandler extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        // Check if we have an error object
        if (this.props.errorObject !== undefined) {
            // Check in this object if we have a specified error for this field
            if (this.props.errorObject[this.props.fieldName] !== undefined) {
                return <div className="form-error alert alert-danger">{this.props.errorObject[this.props.fieldName]}</div>;
            } else if (this.props.fieldName === "all") {
                let msg = [];
                Object.keys(this.props.errorObject).forEach((key) => {
                    msg.push(
                        <div className="form-error alert alert-danger" key={key}>
                            {this.props.errorObject[key]}
                        </div>
                    );
                });
                return msg;
            }
        }

        // No error, return false
        return false;
    }
}
